export default {
  power: 1,
  developer: 2,
  advanced: 3,
  basic: 4
}
